export const maskEmail = text => {
    let position = text.search('@');
    let subString = text.slice(1, position - 2);
    let newString = '*'.repeat(subString.length);
    let emailReplaced = text.replace(subString, newString);
    return emailReplaced;
};
